// Do not remove license for legal reasons.
import {} from './license.js';

import React, { Suspense, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

//import "./UI/assets/css/material-dashboard-react.css?v=1.10.0";
//import "./UI/antd.css";
import './UI/assets/css/styles_v2.css';

import { Provider } from 'react-redux';
import store from './store';

import { useRoutes, useRedirect, navigate } from 'hookrouter';
import { useSelector } from 'react-redux';

import { startUp } from './UI/views/Login/loginSlice';
import { routeActiveKey } from './UI/components/Sidebar/sidebarSlice';

import routes from './routes';

import loginValidator from './UI/loginValidator';
import ErrorBoundary from './UI/components/ErrorBoundary';
import ServerUnavailable from './UI/components/ServerUnavailable';
import { Icon404 } from './assets/NomIcon';

import { checkReady } from './UI/views/Setup/setupSlice';

const MyApp = () => {
  const [bufferSet, setBufferSet] = useState(false);
  const [buffer, setBuffer] = useState(null);

  useRedirect('/', '/00000-00000/tasks');
  const routeResult = useRoutes(routes);
  store.dispatch(startUp());
  store.dispatch(routeActiveKey());

  const authenticated = useSelector((state) => state.login.authenticated);
  const ready = useSelector((state) => state.setup.ready);

  const readyChecked = useSelector((state) => state.setup.readyChecked);
  const readyError = useSelector((state) => state.setup.readyError);
  if (!readyChecked) {
    store.dispatch(checkReady());
  }

  // loginValidator() calls useSelector, so it must run before the early return below to keep
  // the hook order stable across renders.
  loginValidator();

  // The readiness check failed (network/server error): don't guess setup vs. login.
  if (readyError) {
    return <ServerUnavailable />;
  }

  if (!ready) {
    navigate('/setup');
  } else if (!authenticated && !['/oauth/callback', '/auth/callback'].includes(window.location.pathname)) {
    if (!bufferSet) {
      setBuffer(window.location.pathname);
      setBufferSet(true);
    }
    navigate('/login');
  }
  if (window.location.pathname == '/login' && authenticated) {
    if (buffer) {
      navigate(buffer);
      setBuffer(null);
      setBufferSet(false);
    } else {
      navigate('/00000-00000/tasks');
    }
  }

  if (window.location.pathname == '/setup' && ready) {
    navigate('/00000-00000/tasks');
  }

  return routeResult || <NotFoundPage />;
};

function NotFoundPage() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'var(--bright-white, #F4F5F0)',
        textAlign: 'center',
        fontFamily: '"Just Sans", sans-serif',
        color: '#16151D',
      }}
    >
      <Icon404 style={{ fontSize: '252px', marginBottom: '24px' }} />
      <h2 style={{ margin: '0 0 8px', fontSize: '28px', fontWeight: 700 }}>
        404 — Page Not Found
      </h2>
      <p style={{ margin: '0 0 32px', fontSize: '16px', opacity: 0.7 }}>
        The page you're looking for doesn't exist.
      </p>
      <a
        href="/00000-00000/tasks"
        style={{
          background: '#0055FF',
          color: '#fff',
          padding: '10px 24px',
          borderRadius: '6px',
          textDecoration: 'none',
          fontSize: '15px',
          fontWeight: 600,
        }}
      >
        Go to Dashboard
      </a>
    </div>
  );
}

ReactDOM.render(
  <Suspense fallback={<h2>Loading...</h2>}>
    <Provider store={store}>
      <ErrorBoundary>
        <MyApp />
      </ErrorBoundary>
    </Provider>
  </Suspense>,
  document.getElementById('root'),
);
